// initiate home page slider
function loadSlides() {
    let slides = document.querySelectorAll('#slides div');

    if (slides.length > 0) {
        let current = 0;
        slides[current].classList.add('middle');

        setInterval(function () {
            if (current !== slides.length - 1) {
                slides[current + 1].classList.add('middle');
                slides[current].classList.remove('middle');
                current += 1;
            } else {
                slides[0].classList.add('middle');
                slides[current].classList.remove('middle');
                current = 0;
            }
        }, 6000);
    }
}